module.exports = __webpack_public_path__ + "img/4d73460.jpg";